import en from "./en"
// import de from "./de"

export const localize = id => en[id]
